import React from 'react';
import ReactDOM from 'react-dom';
import {ListViewContextData} from './list-view-composable';
import {ListViewItemId, ListViewRenderItemProps} from './list-view-types';
import {ContainingListViewIdAttributeName} from './list-view-dom';
import {elementClosest} from '@wix/devzai-utils-dom';

export interface ListViewItemViewWrapperProps<T> {
    id: ListViewItemId;
    renderProps: ListViewRenderItemProps<T>;
    listViewContextData: ListViewContextData;
}

export class ListViewItemViewWrapper<T> extends React.Component<ListViewItemViewWrapperProps<T>> {
    render() {
        return this.props.children;
    }

    componentDidMount() {
        const { listViewContextData, id } = this.props;

        this.focusWhenCurrentListViewItem(listViewContextData.isItemShouldBeFocusedWhenRendered(id));
        listViewContextData.handleItemRendered(id);
    }

    componentDidUpdate(prevProps: Readonly<ListViewItemViewWrapperProps<T>>) {
        if (prevProps.renderProps.isCurrent !== this.props.renderProps.isCurrent) {
            this.focusWhenCurrentListViewItem();
        }
    }

    focusWhenCurrentListViewItem(forceFocus = false) {
        const { listViewContextData, renderProps } = this.props;

        const navigationListId = listViewContextData.navigationListId;
        const listView = listViewContextData.listView;

        if (renderProps.isCurrent) {
            const itemViewElement = ReactDOM.findDOMNode(this) as HTMLElement;

            const itemViewRootElement =
                itemViewElement.getAttribute(ContainingListViewIdAttributeName) === navigationListId
                    ? itemViewElement
                    : (itemViewElement.querySelector(
                          `[${ContainingListViewIdAttributeName}='${navigationListId}']`
                      ) as HTMLElement);

            if (itemViewRootElement) {
                let shouldFocusElement;
                if (forceFocus) {
                    shouldFocusElement = true;
                } else {
                    const containingListViewElement = ReactDOM.findDOMNode(listView) as HTMLElement;
                    const activeElement = document.activeElement;

                    const containingListViewIsFocused =
                        activeElement !== null &&
                        elementClosest(activeElement, el => el === containingListViewElement, true) !== null;

                    shouldFocusElement = containingListViewIsFocused;
                }

                if (shouldFocusElement) {
                    itemViewRootElement.focus();
                }
            }
        }
    }
}
